import { computed, type ComputedRef } from 'vue'

import type { LinkBreadcrumbItem } from '@shared/ui/menus'

import { AppRoute } from '@shared/config'

interface HeaderTutorSlotLogReturn {
  config: ComputedRef<LinkBreadcrumbItem[]>
}

export const useHeaderTutorSlotLog = (): HeaderTutorSlotLogReturn => {
  const config = computed<LinkBreadcrumbItem[]>(() => [
    {
      id: 'shift-control',
      text: 'Demo shift control',
      to: AppRoute.DemosSlotsTracker,
      disabled: false,
    },
    {
      id: 'tutor-slot-log',
      text: 'Tutor slot log',
      to: AppRoute.DemosTutorSlotLog,
      disabled: true,
    },
  ])

  return {
    config,
  }
}
